import { Timestamp } from "@bufbuild/protobuf";

import React from "react";

import {
  Alert,
  Box,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
  useTheme,
} from "@mui/material";
import clsx from "clsx";

import mainStyles from "../../../styles";
import { convertTimestampToDate } from "helpers/time";

interface MapOrgResultDetailsProps {
  summary: Array<[string, string]>;
  closeTime: Timestamp;
}

const MapOrgResultDetails = ({
  summary,
  closeTime,
}: MapOrgResultDetailsProps) => {
  const options: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
    timeZoneName: "short",
  };

  const CompletedDate =
    "Completed on" +
    " " +
    convertTimestampToDate(closeTime).toLocaleString("en-AU", options);

  const theme = useTheme();
  const classes = mainStyles();

  const displayOrgMapResults = () => {
    return summary.map((data, index) => {
      return (
        <TableRow key={index}>
          <TableCell
            className={clsx(
              classes.tableCell,
              classes.leftCell,
              classes.tableLeftColPadding,
            )}
            align="right"
          >
            {data[0]}
          </TableCell>
          <TableCell
            className={clsx(
              classes.tableCell,
              classes.rightCell,
              classes.tableRightColPadding,
            )}
            align="left"
          >
            {data[1]}
          </TableCell>
        </TableRow>
      );
    });
  };

  return (
    <>
      <Alert
        variant="filled"
        severity="success"
        data-testid="alert-message"
        className={clsx(classes.spaceTopSmall, classes.spaceBottomSmall)}
        style={{ flexGrow: 1, justifyContent: "center", width: "100%" }}
      >
        <Typography variant="subtitle2">{CompletedDate}</Typography>
      </Alert>
      <Box
        style={{
          borderColor: theme.palette.divider,
          borderWidth: "1px",
          borderStyle: "solid",
          borderRadius: "5px",
          width: "100%",
        }}
      >
        <Table data-testid="table-mapping-result">
          <TableBody>{displayOrgMapResults()}</TableBody>
        </Table>
      </Box>
    </>
  );
};

export default MapOrgResultDetails;
